import { Component, input } from '@angular/core';

/**
 * What a table shows when it has nothing to show. Nine of the thirteen tables
 * rendered an empty box instead, which reads as a loading bug.
 *
 * In a table's #emptymessage cell it keeps to the width on screen rather than the
 * table's, so a wide table on a phone doesn't cut it off (styles.css).
 */
@Component({
    selector: 'app-empty-state',
    template: `
        <div class="empty-state">
            <i class="empty-state__icon" [class]="icon()" aria-hidden="true"></i>
            <p class="empty-state__title">{{ title() }}</p>
            @if (description()) {
                <p class="empty-state__description">{{ description() }}</p>
            }
            <ng-content />
        </div>
    `,
    styles: `
        .empty-state {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 0.5rem;
            padding: 2.5rem 1.5rem;
            text-align: center;
        }

        .empty-state__icon {
            font-size: 1.5rem;
            color: var(--p-text-muted-color);
        }

        .empty-state__title {
            margin: 0;
            font-size: 0.9375rem;
            font-weight: 600;
        }

        .empty-state__description {
            margin: 0;
            max-width: 32rem;
            color: var(--p-text-muted-color);
            font-size: 0.8125rem;
            line-height: 1.5;
        }
    `
})
export class EmptyStateComponent {
    readonly title = input.required<string>();
    readonly description = input('');
    readonly icon = input('pi pi-inbox');
}
